import BaseAPI from 'api/api'

export interface FindAllInterface {
    clinicNameTh: string,
    clinicNameEn: string,
    phoneNo: string,
    line: string,
    website: string,
    email: string,
    package: string,
    countryId: number,
    provinceId: number,
    districtId: number,
    subDistrictId: number,
    postcode: string,
    addressTh: string,
    addressEn: string,
    hasCertificate: string,
    reBranchCnNumber: string,
    formatBranchCnNumber: string,
    notilineAppointmentCreate: string,
    notilineAppointmentUpdate: string,
    notilineAppointmentPreday: string,
    notilineAppointmentDay: string,
    notilineAppointmentStatus: string,
    cnNumber: string,
    branchCnNumbers: [],
    // Report Scheduler Config
    accountingEmail?: string,
    monthlyAdvanceReportEnabled?: string,
    monthlyAdvanceReportDay?: number,
    monthlyAdvanceReportTime?: string
}

export interface SendReportManuallyResponse {
    success: boolean,
    message: string
}

export default class AboutUs extends BaseAPI {
    static findAboutUs(): Promise<any> {
        return this.api.get('about-us').then((res) => res)
    }

    static updateAboutUs(props: any): Promise<any> {
        return this.api.post('about-us', props).then((res) => res)
    }

    static detailClinic(branchId: number): Promise<any> {
        return this.api.get(`clinic/${branchId}/info`).then((res) => res)
    }

    // Report Scheduler APIs
    static sendAdvanceReportManually(email?: string): Promise<{ data: SendReportManuallyResponse }> {
        const params = email ? `?email=${encodeURIComponent(email)}` : ''
        return this.api.post(`advance-report-scheduler/send${params}`).then((res) => res)
    }

    static triggerAdvanceReportCron(): Promise<any> {
        return this.api.post('advance-report-scheduler/trigger').then((res) => res)
    }
}
